import getCombatantIndexById from './getCombatantIndexById'
import store from '../store/index'
import blankAction from '../assets/images/bbBlankAction.png'
//----------------
// set blank slot
//----------------
export default function setBlankCA(parm) {
  // console.log("-----------------------------------");
  // console.log("IN setBlankCA parm.ca_num = " + parm.ca_num);
  //--------------
  // access store
  //--------------
  const this_store = store.state.combat
  let combatants = this_store.arena.arena_combatants
  //--------------------------
  // get active combatant idx
  //--------------------------
  let i = getCombatantIndexById(parm.id)
  // if (i > -1) {
  //------------------
  // set var ca props
  //------------------
  let ca = 'ca' + parm.ca_num
  let ca_name = 'ca_name' + parm.ca_num
  let ca_slug = 'ca_slug' + parm.ca_num
  let ca_type = 'ca_type' + parm.ca_num
  //----------------
  // set blank slot
  //----------------
  combatants[i][ca] = blankAction
  combatants[i][ca_name] = 'blank'
  combatants[i][ca_slug] = ''
  combatants[i][ca_type] = ''
  // }
}
